import { render, staticRenderFns } from "./RecruiterAiCandidateCard.vue?vue&type=template&id=48d0bc1f&scoped=true"
import script from "./RecruiterAiCandidateCard.vue?vue&type=script&lang=ts"
export * from "./RecruiterAiCandidateCard.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterAiCandidateCard.vue?vue&type=style&index=0&id=48d0bc1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0bc1f",
  null
  
)

export default component.exports